import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { getCollaborationDataLoading: true, data: '', error: false };

export function collaborationMainDataReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_COLLOBORATION_DATA:
            return {
                getCollaborationDataLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_COLLOBORATION_DATA:
            return {
                getCollaborationDataLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ERRO_COLLOBORATION_DATA:
            return {
                getCollaborationDataLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}

// REQUEST_COLLOBORATION_DATA: 'REQUEST_COLLOBORATION_DATA',
//     RECEIVE_COLLOBORATION_DATA: 'RECEIVE_COLLOBORATION_DATA',
//     ERRO_COLLOBORATION_DATA: 'ERRO_COLLOBORATION_DATA',


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/collaborationData.reducer.js